module.exports = __webpack_public_path__ + "static/media/slderImg3.bcbe1690.png";